var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSnap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    height: 375,
    viewBox: "0 0 375 375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7",
    "data-name": "\\uADF8\\uB8F9 7",
    transform: "translate(-365 -337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_58",
    "data-name": "\\uC0AC\\uAC01\\uD615 58",
    transform: "translate(365 337)",
    fill: "#fff",
    stroke: "#e4e4e4",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 375,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 373,
    height: 373,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_193",
    "data-name": "\\uADF8\\uB8F9 193",
    transform: "translate(483 455)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_5",
    "data-name": "\\uC120 5",
    y2: 140,
    transform: "translate(70)",
    fill: "none",
    stroke: "#e4e4e4",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_6",
    "data-name": "\\uC120 6",
    y2: 140,
    transform: "translate(140 70) rotate(90)",
    fill: "none",
    stroke: "#e4e4e4",
    strokeWidth: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSnap);
export default __webpack_public_path__ + "static/media/add_snap.73de3c29530fcca5ced7dc53eb1d11fe.svg";
export { ForwardRef as ReactComponent };